import {
	ComponentOptions,
	IComponentBindings,
	IQuerySuccessEventArgs,
	Initialization,
	QueryEvents
	} from 'coveo-search-ui';

import { AtlasComponent } from "./../models/AtlasComponent";
import { IDynamicTextOptions, DynamicText } from "./../models/DynamicTextOptions";

export class TotalCount extends AtlasComponent {
	static ID = "TotalCount";
	static options: IDynamicTextOptions = {
		authorDefinedText: ComponentOptions.buildStringOption({
			defaultValue: "{total} result(s) found"
		})
	};
	public dynamicText: DynamicText;

	constructor(element: HTMLElement, options: IDynamicTextOptions, bindings: IComponentBindings) {
		super(element, TotalCount.ID, bindings);
		this.dynamicText = new DynamicText(element, TotalCount, options);
		this.bind.onRootElement(QueryEvents.querySuccess, (data: IQuerySuccessEventArgs) => this.handleQuerySuccess(data));
	}

	private handleQuerySuccess(data: IQuerySuccessEventArgs) {
		var value = this.dynamicText.generateText({ total: data.results.totalCountFiltered });
		this.domElement.setHtml(value);
	}
}

Initialization.registerAutoCreateComponent(TotalCount);



// WEBPACK FOOTER //
// ./src/source/Atlas.SEF.Feature.Common/Areas/AtlasCommon/Assets/Search/components/TotalCount.ts